// TODO: Add icon classNames
export const AssetTypeIcon = Object.freeze({
    deleted: 'glyphicon glyphicon-trash',
    document: 'glyphicon glyphicon-file',
    expired: 'glyphicon glyphicon-time',
    image: 'glyphicon glyphicon-picture',
    video: 'glyphicon glyphicon-facetime-video',
} as const);

export type AssetViewOption = 'list' | 'thumbnail';

export type AssetDisplayStyle = 'deselected' | 'normal' | 'selected';
